import { Box, Typography, Button, styled } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  padding: "32px 40px",
  maxHeight: "80vh",
  overflowY: "auto",
  boxSizing: "border-box",
});

export const ModalTitle = styled(Typography)({
  fontFamily: '"Sora", sans-serif',
  fontSize: "22px",
  fontWeight: 600,
  color: colors.text.primary,
  marginBottom: "4px",
});

export const ModalSubtitle = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  color: colors.text.secondary,
  marginBottom: "24px",
});

export const SectionDivider = styled(Box)({
  height: "1px",
  backgroundColor: colors.border.light,
  margin: "20px 0",
});

export const SectionLabel = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "11px",
  fontWeight: 700,
  letterSpacing: "0.08em",
  color: colors.text.secondary,
  textTransform: "uppercase",
  marginBottom: "16px",
});

export const InfoBanner = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
  backgroundColor: colors.background.lightBlue,
  borderRadius: "8px",
  padding: "12px 16px",
  marginBottom: "16px",
  color: colors.text.link,
});

export const InfoBannerText = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "13px",
  color: colors.text.link,
  lineHeight: 1.5,
});

export const FieldContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  marginBottom: "14px",
});

export const FieldLabel = styled(Typography)({
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  fontWeight: 400,
  color: colors.text.secondary,
});

export const RequiredMark = styled("span")({
  color: "inherit",
});

export const StyledInput = styled("input", {
  shouldForwardProp: (prop) => prop !== "hasError",
})<{ hasError?: boolean }>(({ hasError }) => ({
  width: "100%",
  height: "44px",
  padding: "0 16px",
  border: `1px solid ${hasError ? colors.status.error : colors.border.light}`,
  borderRadius: "8px",
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  color: colors.text.primary,
  backgroundColor: colors.background.secondary,
  outline: "none",
  boxSizing: "border-box",
  cursor: "text",
  "&:focus": {
    borderColor: hasError ? colors.status.error : colors.primary.main,
  },
  "&::placeholder": {
    color: colors.text.secondary,
  },
  "&:disabled": {
    color: colors.text.secondary,
    backgroundColor: colors.background.default,
    cursor: "default",
  },
}));

export const PhoneInputWrapper = styled(Box)({
  "& > div > div": {
    borderWidth: "1px !important",
    backgroundColor: `${colors.background.secondary} !important`,
  },
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "12px",
  marginTop: "28px",
});

export const CancelButton = styled(Button)({
  minWidth: "100px",
  height: "44px",
  border: `1px solid ${colors.border.light}`,
  color: colors.text.primary,
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: colors.background.default,
    borderColor: colors.border.medium,
  },
});

export const SubmitButton = styled(Button)({
  minWidth: "140px",
  height: "44px",
  backgroundColor: colors.primary.main,
  color: colors.text.white,
  fontFamily: '"Nunito", sans-serif',
  fontSize: "14px",
  fontWeight: 700,
  textTransform: "none",
  borderRadius: "8px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: colors.primary.dark,
    boxShadow: "none",
  },
  "&:disabled": {
    backgroundColor: colors.border.light,
    color: colors.text.secondary,
  },
});
